import { ItemCompleteProps } from "app/shared/components/modal/auto-complete/auto-complete";
import i18n from "app/shared/language/i18n";
import { RESPONSEDATA } from "app/shared/services/services-model.type";

interface ProviderBilling {
  ID: string;
  NAME: string;
  Other: string;
}

interface ServiceBilling {
  ID: string;
  NAME: string;
  NAME_DESC: {
    name_vi: string;
    name_en: string;
  };
  PROVIDER: ProviderBilling[];
  CODE: string;
  URL: string;
  priority: number;
}

export interface BillingDataJson {
  SERVICE: ServiceBilling[];
}

let billingSerViceJson: BillingDataJson;

export function loadBillingServiceJson() {
  return new Promise(async (resolve) => {
    if (!billingSerViceJson) billingSerViceJson = await import("../../../shared/util/data-json/billing.json");
    resolve(0);
  });
}

export const handlerBillingServices = () => {
  const list: ItemCompleteProps[] = [];
  const serviceJson: ServiceBilling[] = billingSerViceJson.SERVICE;
  serviceJson.forEach((_item) => {
    let name = i18n.language === "en" ? _item.NAME_DESC.name_en : _item.NAME_DESC.name_vi;
    list.push({ value: _item.ID || "", label: name, icon: _item.URL });
  });
  return list;
};

export const handlerBillingProviders = (service?: string) => {
  const list: ItemCompleteProps[] = [];
  const serviceJson: ServiceBilling[] = billingSerViceJson.SERVICE;
  serviceJson.filter((_item) => {
    if (_item.ID === service) {
      _item.PROVIDER.forEach((_provider) => {
        list.push({ value: _provider.ID || "", label: _provider.NAME });
      });
    }
  });
  return list;
};

export const handlerBillingPackages = (data?: RESPONSEDATA) => {
  const list: ItemCompleteProps[] = [];
  const indexList = data?.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
  if (indexList && indexList.hasOwnProperty("38") && indexList["38"].LIST_CONTROL_VALUE?.length) {
    indexList["38"].LIST_CONTROL_VALUE.forEach((item) => {
      list.push({ value: item.ID || "", label: item.NAME || "", other: item.Other || "" });
    });
  }
  return list;
};

export const getBillingService = (value?: string) => {
  const serviceJson: ServiceBilling[] = billingSerViceJson.SERVICE;
  const filterList = serviceJson.filter((_item) => {
    return _item.ID === value;
  });
  if (filterList.length) return filterList[0];
  return;
};

export const getBillingProvider = (service?: string, provider?: string) => {
  let providerList: ProviderBilling[] = [];
  const serviceJson: ServiceBilling[] = billingSerViceJson.SERVICE;
  const serviceFilter = serviceJson.filter((_item) => {
    return _item.ID === service;
  });
  if (serviceFilter.length) {
    providerList = serviceFilter[0].PROVIDER.filter((_provider) => {
      return _provider.ID === provider;
    });
    if (providerList.length) return providerList[0];
  }
  return;
};

export const getBillingPackage = (data?: RESPONSEDATA, value?: string) => {
  const indexList = data?.CONTROLVALUE?.INDEX_LIST_CONTROL_VALUE;
  if (indexList && indexList.hasOwnProperty("38") && indexList["38"].LIST_CONTROL_VALUE?.length) {
    const filterList = indexList["38"].LIST_CONTROL_VALUE.filter((item) => {
      return item.ID === value;
    });
    if (filterList.length) return filterList[0];
  }
  return;
};
